export default __webpack_public_path__ + "img/6843fe54d56354724ebe6b0bc19a769d.jpg";